module.exports = __webpack_public_path__ + "img/sinBarrreras244.f6ac8a6d.jpg";